import React, { useState } from "react";
import styled from "styled-components";
import {
  IconButton,
  IconButtonResponsive,
} from "../../../components/ButtonsNew";
import { FilterIconOrange } from "../../../shared/icons";
import FilterDrawer from "../FilterDrawer";
import { screenSizes } from "../../../styles/theme";

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;

const TitleContainer = styled.div`
  color: #091c00;
  h2 {
    font-family: "Manrope", sans-serif;
    font-size: 50px;
    font-weight: 700;
    letter-spacing: -2px;
    margin: 0;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 32px;
      letter-spacing: 0;
      line-height: 40px;
    }
  }

  h5 {
    font-family: "Manrope", sans-serif;
    color: rgba(9, 28, 0, 0.8);
    font-size: 18px;
    font-weight: 400;
    margin: 0;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 16px;
      width: 80%;
      padding-top: 12px;
    }
  }
`;

interface Props {
  heading: string;
  subHeading?: string;
  getFilteredNFTs: (
    name: string,
    rank_by: string,
    limit?: number,
    pageNo?: number,
    isLoadingMore?: boolean
  ) => void;
}

const HeaderWithFilter: React.FC<Props> = ({
  heading,
  subHeading,
  getFilteredNFTs,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const isMobile = window.innerWidth <= 1024;

  const handleToggleFilter = () => {
    setIsFilterOpen((prev) => !prev);
  };

  return (
    <>
      <HeaderContainer>
        <TitleContainer>
          <h2>{heading}</h2>
          <h5>{subHeading}</h5>
        </TitleContainer>
        {!isMobile ? (
          <IconButton icon={<FilterIconOrange />} onClick={handleToggleFilter}>
            Filter
          </IconButton>
        ) : (
          <IconButtonResponsive
            icon={<FilterIconOrange />}
            onClick={handleToggleFilter}
          >
            {""}
          </IconButtonResponsive>
        )}
      </HeaderContainer>

      <FilterDrawer
        isOpen={isFilterOpen}
        onClose={handleToggleFilter}
        getFilteredNFTs={getFilteredNFTs}
      />
    </>
  );
};

export default HeaderWithFilter;
